import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { m } from "framer-motion";

const CTA = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (trimmed) {
      navigate(`/register?email=${encodeURIComponent(trimmed)}`);
    } else {
      navigate("/register");
    }
  };

  return (
    <div className="pt-[40px] pb-[100px] px-4 text-center bg-white">
      <m.div
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: 0.2,
            },
          },
        }}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="max-w-[553px] mx-auto space-y-8"
      >
        <m.h2
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: {
              opacity: 1,
              y: 0,
              transition: { duration: 0.6, ease: "easeOut" },
            },
          }}
          className="text-[36px] md:text-[42px] lg:text-[60px] leading-tight font-bold text-[#09042C]"
        >
          Get early access
        </m.h2>
        <m.p
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: {
              opacity: 1,
              y: 0,
              transition: { duration: 0.6, ease: "easeOut" },
            },
          }}
          className="text-black text-center text-[18px] md:text-[20px] lg:text-[22px]"
        >
          Register to get early access and be the first to try our platform.
        </m.p>

        <m.form
          onSubmit={handleSubmit}
          variants={{
            hidden: { opacity: 0, y: 20, scale: 0.95 },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
              transition: { duration: 0.6, ease: "easeOut" },
            },
          }}
          className="flex items-center p-1.5 rounded-[500px] border border-[#CECECE] bg-white shadow-sm max-w-[480px] mx-auto overflow-hidden"
        >
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 px-4 md:px-6 py-2 bg-transparent border-none focus:outline-none focus:ring-0 text-slate-600 placeholder:text-[#CECECE] text-base md:text-lg min-w-0"
          />

          <m.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            type="submit"
            className="cursor-pointer bg-gradient-to-r from-[#FF974D] to-[#F36047] hover:from-[#FF8C42] hover:to-[#F36047] rounded-[45px] text-white px-5 md:px-8 py-2 md:py-3 font-bold transition-all shadow-md shrink-0 text-sm md:text-base whitespace-nowrap"
          >
            Register Now
          </m.button>
        </m.form>
      </m.div>
    </div>
  );
};

export default CTA;
